module.exports = __webpack_public_path__ + "img/help-curves.3df19073.webp";